let env = {};

env.baseURL = 'https://api.checklist-hml.it4d.com.br/api/v1/';
env.normalURL = 'https://api.checklist-hml.it4d.com.br/';
env.mode = 'homolog';

export default env
